import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import WeatherStationPanel from "./WeatherStationPanel";
import WeatherStationChart from "./WeatherStationChart";
import NodeDlrPanel from "./NodeDlrPanel";

/**
 * The weather station's view on the node panel: its readings, or the line
 * rating those readings give at this span (#247). Weather is the default tab,
 * so the panel opens exactly as it did before the rating existed.
 *
 * Mounted with key={deviceId}, so opening another station starts on Weather.
 */
export default function WeatherNodeTabs({ deviceId, apiBaseUrl, t, simulated, lineBearingDeg, offCorridor = false }) {
  const [tab, setTab] = useState("weather");
  return (
    <Box>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tab value="weather" label={t("dlrTabWeather")} sx={{ textTransform: "none" }} />
        <Tab value="dlr" label={t("dlrTab")} sx={{ textTransform: "none" }} />
      </Tabs>
      {tab === "weather" ? (
        <>
          <Box sx={{ mt: 3 }}>
            <WeatherStationPanel deviceId={deviceId} apiBaseUrl={apiBaseUrl} label={deviceId} t={t} simulated={simulated} />
          </Box>
          <Box sx={{ mt: 3 }}>
            <WeatherStationChart deviceId={deviceId} apiBaseUrl={apiBaseUrl} label={deviceId} t={t} simulated={simulated} />
          </Box>
        </>
      ) : (
        <Box sx={{ mt: 3 }}>
          <NodeDlrPanel
            deviceId={deviceId}
            apiBaseUrl={apiBaseUrl}
            t={t}
            simulated={simulated}
            lineBearingDeg={lineBearingDeg}
            offCorridor={offCorridor}
          />
        </Box>
      )}
    </Box>
  );
}
